import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { parseHtml } from '@change-corgi/core/react/html';

import { BannerWrapper } from 'src/app/shared/components/banners/layout';

type Props = {
	message: string;
};

export function MaintenanceBanner({ message }: Props): JSX.Element | null {
	return (
		<BannerWrapper py={4}>
			<Text as="div" size="small">
				{parseHtml(message)}
			</Text>
		</BannerWrapper>
	);
}
